const Inbox = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.875 9H4.41147C4.92538 9 5.39518 9.29035 5.625 9.75C5.85482 10.2096 6.32462 10.5 6.83853 10.5H11.1615C11.6754 10.5 12.1452 10.2096 12.375 9.75C12.6048 9.29035 13.0746 9 13.5885 9H16.125M6.72492 3H11.2751C12.0827 3 12.4866 3 12.8431 3.12297C13.1584 3.23172 13.4455 3.4092 13.6838 3.64256C13.9532 3.90645 14.1338 4.26765 14.495 4.99003L16.1199 8.23988C16.2617 8.52337 16.3326 8.66511 16.3825 8.81366C16.4269 8.94559 16.459 9.08135 16.4783 9.2192C16.5 9.37442 16.5 9.53289 16.5 9.84984V11.4C16.5 12.6601 16.5 13.2902 16.2548 13.7715C16.039 14.1948 15.6948 14.539 15.2715 14.7548C14.7902 15 14.1601 15 12.9 15H5.1C3.83988 15 3.20982 15 2.72852 14.7548C2.30516 14.539 1.96095 14.1948 1.74524 13.7715C1.5 13.2902 1.5 12.6601 1.5 11.4V9.84984C1.5 9.53289 1.5 9.37442 1.52173 9.2192C1.54103 9.08135 1.57308 8.94559 1.61747 8.81366C1.66745 8.66511 1.73832 8.52336 1.88006 8.23988L3.50498 4.99003C3.86618 4.26764 4.04678 3.90645 4.31621 3.64256C4.55447 3.4092 4.84164 3.23172 5.15692 3.12297C5.51344 3 5.91727 3 6.72492 3Z"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Inbox;
